import UserService from "./service/UserService";

const userService = new UserService();
export function closeFromParent(){
    const data = {
        action: "close_app",
        payload: {
            app_key: localStorage.getItem("appKey"), 
            user: {
             email: localStorage.getItem("appUser"),
            }
        },
    }
    window.parent.postMessage(data, "*");      
}

export function submitCompletion(){
    const appUser = localStorage.getItem("appUser");
    const appClient = localStorage.getItem("appKey");
    const payload = {
        action: "update_th",
        appKey: appClient,
        value: 1
    }
    window.parent.postMessage(payload, "*");      

    userService.getUsers().then((data) => {
        data = data.filter((i) => { return i.playerparentemail });
        const userData = data.find((u) => u.playerparentemail.toLowerCase() === appUser.toLowerCase())
        if(!userData) return;
        switch(appClient){
            case "time-machine":
                userService.updateUser(userData.id, {CompleteTH2022TimeMachineIS: 1})
                break;
            case "maths-ninja":
                userService.updateUser(userData.id, {CompleteTH2022MathsNinjaIS: 1})
                break;
            case "cleanliness":
                userService.updateUser(userData.id, {CompleteTH2022CleanlinessIS: 1})
                break;
            default:
                break;
        }
    }).catch((e) => {
        console.log(e);
    }); 
}

export function submitReferrer(data){
    const payload = {
        action: "add_referrer_th",
        appKey: localStorage.getItem("appKey"),
        value: data
    }
    window.parent.postMessage(payload, "*");      
    localStorage.setItem('appReferrer', data);
}